module.exports = __webpack_public_path__ + "static/assets/8817056448badfc2f16590ca4da4e553.svg";